<template>
  <div>
    <router-view class="p-5" />
  </div>
</template>

<script>
export default {
}
</script>
